












import { Component, Prop, Vue } from "vue-property-decorator";
import { IState } from "@/store";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState({
      activeLocaleCode: (state: IState) => state.i18n.activeLocaleCode
    })
  }
})
export default class LocationMap extends Vue {
  // Props

  @Prop({ default: true })
  public showMap!: boolean;

  @Prop({ default: "London+GB" })
  public location!: string;

  @Prop({ default: 420 })
  public width!: number;

  @Prop({ default: 200 })
  public height!: number;

  //  Vuex bindings

  public activeLocaleCode!: string;

  // Computed

  public get src() {
    return `https://www.google.com/maps/embed/v1/place?${[
      `key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}`,
      `language=${this.activeLocaleCode}`,
      `q=${this.location}`,
      `zoom=5`
    ].join("&")}`;
  }
}
